import { API_DOMAIN, notificationStrings } from '@constants/app-constants';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import Actions from '../action';
import DeliveryCardPresentational from './delivery-card-presentational';
import Selectors from '../selectors';
import axios from 'axios';
import { connect } from 'react-redux';
import { openNotificationWithIcon } from '@sharedComponent/notification-message/notification';

const DeliveryCardFunctional = ({
	allowNavigate,
	buttonMode,
	buttonName,
	navigateDisabled,
	companyInfoDetails,
	getDeliveryInfoStart,
	deliveryInfoData,
	isdeliveryLoading,
}) => {
	// const { state: { companyId } = {} } = useLocation();
	const companyId = localStorage.getItem('companyId');
	console.log('LOCAL DELIVERY ::', companyId);
	useEffect(() => {
		allowNavigate?.(1);
		buttonMode?.('single');
		buttonName?.('Next');
		getDeliveryInfoStart(companyId);
	}, []);
	const [deliverySavingData, setDeliverySavingData] = useState(false);
	const history = useHistory();

	const handleSubmit = (deliveryInfo, mainPayrollCheckBox) => {
		console.log('PAYLOAD ::', deliveryInfo);
		deliveryInfo.emirateName = deliveryInfo.emirateName ? deliveryInfo.emirateName.replace(/ +/g, '') : '';
		deliveryInfo.cardDeliveryAddressId =
			deliveryInfoData && deliveryInfoData.cardDeliveryAddressId ? deliveryInfoData.cardDeliveryAddressId : null;
		deliveryInfo.contactList =
			deliveryInfo.contactList && deliveryInfo.contactList.length > 0
				? deliveryInfo.contactList.map((info, i) => {
					return {
						contactId: info?.contactId || null,
						contactType: info?.contactType || null,
						email: info?.hrEmail || null,
						landLine: info?.hrLandline || null,
						mobile: info?.hrMobile || null,
						name: info?.hrName || null,
					};
				})
				: [];

		if (mainPayrollCheckBox) {
			delete deliveryInfo.contactList;
		}

		setDeliverySavingData(true);
		axios
			.patch(`${API_DOMAIN}/CardDeliveryAddress/${companyId}/update`, deliveryInfo)
			.then(() => {
				openNotificationWithIcon(notificationStrings.success, 'Delivery Info Saved Successfully.');
				setDeliverySavingData(false);
				history.push('/user/contactinfo/3');
			})
			.catch(() => {
				setDeliverySavingData(false);
			});
	};
	// console.log('DATA ::', deliveryInfoData);

	return (
		<>
			<DeliveryCardPresentational
				navigateDisabled={navigateDisabled}
				companyInfoDetails={companyInfoDetails}
				deliveryInfoData={deliveryInfoData}
				isdeliveryLoading={isdeliveryLoading}
				deliverySavingData={deliverySavingData}
				handleSubmit={handleSubmit}></DeliveryCardPresentational>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		deliveryInfoData: Selectors.deliveryInfoData(state),
		isdeliveryLoading: Selectors.isdeliveryLoading(state),
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		getDeliveryInfoStart: (companyId) => dispatch(Actions.creators.getDeliveryInfoStart(companyId)),
	};
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(DeliveryCardFunctional);
export default Connected;
